import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import TuneIcon from "@mui/icons-material/Tune";
import { useTheme } from "@mui/material/styles";
import { useChatSessionsContext } from "../lib/contexts/ChatSessionsContext";

interface ChatFiltersProps {
  isExpanded: boolean;
  onIsExpandedChange: () => void;
}

const ChatFilters: React.FC<ChatFiltersProps> = ({
  isExpanded,
  onIsExpandedChange,
}) => {
  const theme = useTheme(); // Use the useTheme hook to get the theme object
  const { filterCourseType, setFilterCourseType } =useChatSessionsContext();
  const [courseType, setCourseType] = useState<string>(filterCourseType ?? "");

  useEffect(() => {
    setCourseType(filterCourseType ?? "")
  }, [filterCourseType]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      onIsExpandedChange();
    };

  const handleReset = () => {
    setCourseType("")
    setFilterCourseType(null)
  };

  const handleSave = () => {
    onIsExpandedChange();
  };

  const handleCourseTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCourseType(event.target.value)
    setFilterCourseType(event.target.value)
  }

  return (
    <Box
      sx={{
        background: "rgba(245, 245, 245, 1)",
        paddingLeft: "5%",
        paddingRight: "5%",
        display: "flex",
        paddingBottom: "1%",
        flexDirection: "column",
        width: "-webkit-fill-available",
        marginTop: "10px",
      }}
    >
      <Accordion
        elevation={0}
        expanded={isExpanded}
        onChange={handleChange("sources")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="sources-content"
          id="sources-header"
          color={"primary"}
          sx={{ backgroundColor: "rgba(245, 245, 245, 1)" }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TuneIcon
              sx={{ marginRight: "5px", color: "#1976D2" }}
              fontSize="inherit"
            />
            <Typography color={"#1976D2"} variant="h6">
              Metadata Filters
              <Tooltip
                placement="right"
                title="Metadata filters will restrict the documents that the large
              language model will consider when generating responses."
              >
                <InfoIcon sx={{ marginLeft: "2px" }} fontSize="inherit" />
              </Tooltip>
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormControl component="fieldset">
              <FormLabel
                sx={{
                  fontWeight: "bold",
                  marginBottom: theme.spacing(1),
                  padding: theme.spacing(2),
                  paddingLeft: 0,
                  paddingTop: 0,
                }}
                component="legend"
              >
                Course Type
              </FormLabel>
              <Box sx={{ display: "flex", gap: 2 }}>
              <RadioGroup
                aria-labelledby="course-type"
                defaultValue="female"
                value={courseType}
                onChange={handleCourseTypeChange}
              >
                <FormControlLabel value="core" control={<Radio />} label="Core" />
                <FormControlLabel value="elective" control={<Radio />} label="Elective" />
              </RadioGroup>
              </Box>
              <Box
                sx={{ marginTop: theme.spacing(3), display: "flex", gap: 2 }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </Box>
            </FormControl>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ChatFilters;
